import * as React from 'react';

import { Box } from '../../../Common/Box';
import { SideToolbar, SideToolbarProps } from './SideToolbar';

interface BasicSideToolbarProps extends SideToolbarProps {}

export const SideToolbarOnFocus = (props: BasicSideToolbarProps) => {
  const { children } = props;

  return (
    <SideToolbar {...props}>
      <Box padding="12px">{children}</Box>
    </SideToolbar>
  );
};
